document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.singles-grid').forEach(function (grid) {
    const buttons = grid.querySelectorAll('.singles-grid__filter');
    const cards = grid.querySelectorAll('.singles-grid__card');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const filter = btn.dataset.filter;
        cards.forEach(function (card) {
          const tags = card.dataset.tags || '';
          card.style.display = (filter === 'all' || tags.indexOf(filter) !== -1) ? '' : 'none';
        });
      });
    });
  });
});
